<template>
  <div class="form-field">
    <label
      class="form-field__label"
      v-if="label"
    >{{ label }}</label>
    <div
      class="form-field__control"
      :class="{ 'form-field__control--has-icon': icon }"
    >
      <slot />
      <span
        class="form-field__icon"
        v-if="icon"
        @click.prevent="$emit('icon-click')"
      >
        <font-awesome-icon :icon="icon" />
      </span>
    </div>
    <p
      class="form-field__help"
      v-if="message"
    >
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
    name: 'BaseFormField',
    props: {
        icon: {
            type: String,
            default: undefined,
        },
        label: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.form-field {
    position: relative;
    width: 100%;

    &:not(:last-child) {
        margin-bottom: 10px;
    }

    &__label {
        font-size: 13px;
        margin-bottom: 5px;
        color: $black;
        display: inline-block;
    }
    &__control {
        position: relative;
        display: flex;
    }
    &__icon {
        max-width: 20px;
        max-height: 20px;
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
    }
    &__help {
        font-size: 11px;
        color: $black2;
        margin-top: 4px;
        font-style: italic;
    }
}
</style>
